import { useQuery } from "@tanstack/react-query";
import { getNewsApi } from "../../../api/resources.api";
import { News, NewsResponse,UseNewsOptions } from "../../../types/index";

export const useNews = (options: UseNewsOptions = {}) => {
  const { projects, exclude_id, search, category, is_featured } = options;

  return useQuery<News[], Error>({
    queryKey: [
      "news",
      { projects, exclude_id, search, category, is_featured },
    ],

    queryFn: async () => {
      const response: NewsResponse = await getNewsApi({
        projects,
        exclude_id,
        search,
        category,
        is_featured,
      });

      if (!response?.status || !Array.isArray(response.data)) {
        throw new Error("Invalid news data format");
      }

      return response.data.map((news) => ({
        ...news,
        release_date: news.release_date ?? news.date_release ?? null,
        date_release: news.release_date ?? news.date_release ?? null,
        images: news.images?.map((img) => ({
          ...img,
          url:
            typeof img.url === "string"
              ? img.url.replace(/\\/g, "")
              : img.url,
        })),
      }));
    },

    enabled: options.enabled ?? true,
    initialData: options.initialData,
    staleTime: 1000 * 60 * 3,
    retry: 1,
  });
};